module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meu-perfil notificacoes"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "perfil-items"
  }, [_c('div', {
    staticClass: "perfil-item"
  }, [_c('div', {
    staticClass: "perfil-label"
  }, [_vm._v("SMS")]), _vm._v(" "), _c('div', {
    staticClass: "perfil-text"
  }, [_c('v-switch', {
    attrs: {
      "color": "orange darken-3"
    },
    model: {
      value: (_vm.data.sms),
      callback: function($$v) {
        _vm.$set(_vm.data, "sms", $$v)
      },
      expression: "data.sms"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "perfil-item"
  }, [_c('div', {
    staticClass: "perfil-label"
  }, [_vm._v("Notas")]), _vm._v(" "), _c('div', {
    staticClass: "perfil-text"
  }, [_c('v-switch', {
    attrs: {
      "color": "orange darken-3"
    },
    model: {
      value: (_vm.data.notificacoes_notas),
      callback: function($$v) {
        _vm.$set(_vm.data, "notificacoes_notas", $$v)
      },
      expression: "data.notificacoes_notas"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "perfil-item"
  }, [_c('div', {
    staticClass: "perfil-label"
  }, [_vm._v("Provas")]), _vm._v(" "), _c('div', {
    staticClass: "perfil-text"
  }, [_c('v-switch', {
    attrs: {
      "color": "orange darken-3"
    },
    model: {
      value: (_vm.data.notificacoes_provas),
      callback: function($$v) {
        _vm.$set(_vm.data, "notificacoes_provas", $$v)
      },
      expression: "data.notificacoes_provas"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "perfil-item"
  }, [_c('div', {
    staticClass: "perfil-label"
  }, [_vm._v("Agenda")]), _vm._v(" "), _c('div', {
    staticClass: "perfil-text"
  }, [_c('v-switch', {
    attrs: {
      "color": "orange darken-3"
    },
    model: {
      value: (_vm.data.notificacoes_agenda),
      callback: function($$v) {
        _vm.$set(_vm.data, "notificacoes_agenda", $$v)
      },
      expression: "data.notificacoes_agenda"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "perfil-item"
  }, [_c('div', {
    staticClass: "perfil-label"
  }, [_vm._v("Boletos")]), _vm._v(" "), _c('div', {
    staticClass: "perfil-text"
  }, [_c('v-switch', {
    attrs: {
      "color": "orange darken-3"
    },
    model: {
      value: (_vm.data.notificacoes_boletos),
      callback: function($$v) {
        _vm.$set(_vm.data, "notificacoes_boletos", $$v)
      },
      expression: "data.notificacoes_boletos"
    }
  })], 1)])]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.salvarDados()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-check"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Salvar Dados")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "meu-perfil-titulo"
  }, [_c('i', {
    staticClass: "fas fa-bell"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Notificações")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9e2d8c2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/pessoal/components/minha-conta/Notificacoes.vue
// module id = 568
// module chunks = 2